<template>
  <div>
    <div class="available-header">
      <div class="left-wrapper">
        <el-image
          class="currency"
          :src="
            getCurrencyImage('USD')
              ? require(`@/assets/images/currency/${'USD'}.png`)
              : ''
          "
        ></el-image>
        <div>
          <div class="title">Available limit</div>
          <div class="amount">1,000 CNY</div>
        </div>
      </div>
      <div>
        <el-button @click="openUploadModal" type="primary" size="small">Upload order</el-button>
      </div>
    </div>
    <div class="table-wrapper">
      <custom-table
        :table-set="tableCondition"
        ref="table"
        router-name="/transfer/available-limit"
      >
      </custom-table>
    </div>
    <validation-modal ref="uploadModal"
      width="750px"
      :titleText="$t('Upload declaration order')"
      :validation-condition="uploadCondition"
      @refresh="onRefreshTable"
      :default-function="uploadFile">
      <template>
        <div class="upload-template">
          <el-link
            class="download"
            type="primary"
            href="/static/template/restoreDetailedDeclarationTemplate.xlsx"
            :download="`${$t('message.settlement.restoreDetaileddeclaration')}.xlsx`">
            <i class="iconfont icon-Download"></i>
            {{$t('message.settlement.templateDownload')}}
          </el-link>
        </div>
      </template>
    </validation-modal>
  </div>
</template>
<script>
import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import CustomTable from '@/components/table/custom-table.vue';
import { REQUIRED } from '@/components/validation/tool/validator';
import { getCurrencyImage } from '@/utils/tools/currency';

export default {
  components: { CustomTable, ValidationModal },
  data() {
    return {
      tableCondition: [
        {
          // 上传日期
          titleBar: { type: 'text', title: 'message.transfer.uploadDate' },
          key: 'uploadDate',
          type: 'text',
        },
        {
          // 上传序号
          titleBar: { type: 'text', title: 'message.transfer.uploadNumber' },
          key: 'uploadNumber',
          type: 'text',
        },
        {
          // 类型
          titleBar: { type: 'text', title: 'message.collection.type' },
          key: 'uploadNumber',
          type: 'text',
        },
        {
          // 定额
          titleBar: { type: 'text', title: 'message.transfer.quota' },
          key: 'quota',
          type: 'text',
        },
        {
          // 文件名
          titleBar: { type: 'text', title: 'message.download.fileName' },
          key: 'fileName',
          type: 'text',
        },
        {
          // 文件名
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'status',
          type: 'text',
        },
        {
          // 操作
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'operations',
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.see',
              // permissionCode: 'collection:transaction:detail',
              // func: (data) => {
              //   this.$router.push({
              //     path: '/collection/transaction/view',
              //     query: { id: data.id },
              //   });
              // },
            },
          ],
        },
      ],
      uploadCondition: [
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            fileTypeRule: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
          },
        },
      ],
    };
  },
  methods: {
    getCurrencyImage,
    openUploadModal: function() {
      this.$refs.uploadModal.openModal(true);
    },
    onRefreshTable() {
      return this.$refs.table.refreshTable();
    },
    uploadFile() {},
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.available-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0 25px;
  .left-wrapper {
    display: flex;
    align-items: center;
    .currency {
      height: 39px;
      margin-right: 16px;
    }
    .title {
      font-size: 14px;
      font-weight: normal;
      line-height: 24px;
    }
    .amount {
      font-size: 18px;
      font-weight: 800;
      line-height: 24px;
      margin-top: 4px;
    }
  }
}
.upload-template {
  position: absolute;
  top: 85px;
  right: 30px;
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 800;
  color: $color-text-default-button;
}
</style>
